import React, { useState } from "react";
import { Button, InputGroup, Callout } from "@blueprintjs/core";
import { Redirect } from "react-router-dom";

import "./SignIn.css";

const trySigningIn = (auth, setError, username, password) => {
  auth
    .signInWithEmailAndPassword(username, password)
    .then(
      <Redirect
        to={{
          pathname: "/",
        }}
      />
    )
    .catch((error) => {
      const errorMessage = error.message;
      setError(errorMessage);
    });
};

const SignIn = ({ auth }) => {
  const [error, setError] = useState(false);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  return (
    <form id="sign-in-form">
      {error && (
        <Callout title="Error signing in" intent="danger">
          {error}
        </Callout>
      )}
      <div className="input">
        <InputGroup
          leftIcon="user"
          placeholder="Email"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
        />
      </div>
      <div className="input">
        <InputGroup
          leftIcon="lock"
          placeholder="Password"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
      </div>
      <div className="input">
        <Button
          type="submit"
          onClick={(e) => {
            e.preventDefault();
            trySigningIn(auth, setError, username, password);
          }}
        >
          Sign In
        </Button>
      </div>
    </form>
  );
};

export default SignIn;
